import React, { useState, useRef, useEffect } from "react";
import {
  FaChevronUp,
  FaChevronDown,
  FaEllipsisV,
  FaTimes,
  FaCheck,
  FaThumbsUp,
  FaThumbsDown,
  FaUndoAlt,
} from "react-icons/fa";
import Modal from "../../../../../../PageCostumerProfile/PCPContents/Contents/Order History/Modal/Modal";
import ApproveDeclined from "../Modal/ApproveDeclined/ApproveDeclined";
import { useAppContext } from "../../../../../../Components/AppProvider";
import RefundForm from "../Modal/RefundForm/RefundForm";

function _OrderRow({
  transaction,
  menuOpenId,
  setMenuOpenId,
  isSelected,
  onSelect,
  setUpdateDeclinedOrder,
  setCountListUpdate,
}) {
  const { customerId } = useAppContext;
  const [addressId, setAddressId] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");

  const [isModalOpen, setModalOpen] = useState("");
  const handelModal = (cmd) => {
    setModalOpen(cmd); // open modal
  };

  useEffect(() => {
    const getAddressId = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/orders/get-default-address/${customerId}`
        );
        if (!res.ok) {
          throw new Error("Failed to fetch address");
        }

        const data = await res.json();
        //console.log("Address data:", data);

        // Example: if backend returns array of addresses
        const fetchedAddressId = data.addressRow?.[0]?.CA_ID || null;

        //console.log("fetchedAddressId:", fetchedAddressId);

        setAddressId(fetchedAddressId);
      } catch (err) {
        console.error("Error fetching address:", err);
      }
    };

    if (customerId) {
      getAddressId();
    }
  }, [customerId]); // runs again if customerId changes
  const handleRefund = async (reason, selectedFile) => {
    const confirm = window.confirm(
      `Are you sure you want to refund payment for transaction ${transaction.TransactionNumber}?`
    );
    if (!confirm) return;

    try {
      const payload = transaction.OrderItems.map((item) => ({
        COI_ID: item.COI_ID,
        PT_ID: transaction.TransactionID,
      }));

      //console.log("Refund payload:", payload);
      //console.log("Payload for approve:", payload);
      const formData = new FormData();
      formData.append("paymentRefund", JSON.stringify(payload)); // text field
      formData.append("reason", reason);
      if (selectedFile) formData.append("proof", selectedFile); // file field

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/payments/refund-payment`,
        {
          method: "POST",
          body: formData, // no headers — browser sets multipart boundary automatically
          credentials: "include",
        }
      );

      if (res.ok) {
        console.log(`✅ Transaction ${transaction.TransactionNumber} refunded`);
        alert(`✅ Transaction ${transaction.TransactionNumber} refunded`);
        setUpdateDeclinedOrder((prev) => !prev);
        setCountListUpdate((prev) => !prev);
      } else {
        console.error("Failed to decline transaction");
      }
    } catch (err) {
      console.error("Error declining transaction:", err);
    }
  };
  const handleApprove = async (selectedFile) => {
    //console.log(transaction.TotalAmount);
    const confirm = window.confirm(
      `Are you sure you want to approve payment for transaction ${transaction.TransactionNumber}?`
    );
    if (!confirm) return;

    try {
      // Build payload from items
      const payload = transaction.OrderItems.map((item) => ({
        PT_ID: transaction.TransactionID,
        COI_ID: item.COI_ID,
        type: transaction.PaymentType, // ✅ use from parent transaction
        PaymentAmount: transaction.PaymentAmount,
        TotalAmount: item.TotalAmount,
        Downpayment: item.Downpayment,
        Balance: item.Balance,
        Quantity: item.Quantity,
      }));

      //console.log("Payload for approve:", payload);
      const formData = new FormData();
      formData.append("orders", JSON.stringify(payload)); // text field
      if (selectedFile) formData.append("receipt", selectedFile); // file field

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/payments/approve-declined-payment`,
        {
          method: "POST",
          body: formData, // no headers — browser sets multipart boundary automatically
          credentials: "include",
        }
      );

      if (res.ok) {
        setModalOpen(null);
        setUpdateDeclinedOrder((p) => !p);
        setCountListUpdate((prev) => !prev);
        console.log(
          `✅  Transaction ${transaction.TransactionNumber} approved`
        );
        alert(`✅  Transaction ${transaction.TransactionNumber} approved`);
      } else {
        console.error("Failed to approve transaction");
        //console.log(`Failed to approve transaction`);
      }
    } catch (err) {
      console.error("Error approving transaction:", err);
    }
  };
  const [activeTab, setActiveTab] = useState("items");
  const isMenuOpen = menuOpenId === transaction.TransactionID;

  const menuRef = useRef(null);
  const rowRef = useRef(null);

  useEffect(() => {
    if (isOpen && rowRef.current) {
      rowRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [isOpen]);

  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);

    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert to 12-hour format

    return `${mm}/${dd}/${yyyy} ${hours}:${minutes} ${ampm}`;
  };

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        setHeight(`${contentRef.current.scrollHeight}px`);
      } else {
        setHeight("0px");
      }
    }
  }, [isOpen, activeTab, transaction.OrderItems]);

  return (
    <>
      <tr>
        <td
          className="td-toggle-icon"
          onClick={() => setIsOpen(!isOpen)}
          style={{ cursor: "pointer" }}
        >
          {isOpen ? (
            <FaChevronUp className="toggle-icon" title="Collapse" />
          ) : (
            <FaChevronDown className="toggle-icon" title="Expand" />
          )}
        </td>

        <td>{transaction.TransactionNumber}</td>
        <td>{transaction.CustomerName}</td>
        <td>{transaction.OrderItems.length}</td>
        <td>{formatToMMDDYYYY(transaction.DatePurchase)}</td>
        <td>{transaction.PaymentMethod}</td>
        <td>{transaction.PaymentType}</td>
        <td>PHP {transaction.PaymentAmount}</td>
        <td>DECLINED</td>
        <td className="td-actions">
          <div className="td-action-btns-wrapper" ref={menuRef}>
            <FaThumbsUp
              className="readytoship"
              title="APPROVE"
              style={{ color: "green", cursor: "pointer" }}
              onClick={() => handelModal("approve")}
            />
            <FaUndoAlt
              className="refunded"
              title="REFUND"
              style={{ color: "#6c757d", cursor: "pointer" }}
              onClick={() => handelModal("refund")}
            />
          </div>
        </td>
      </tr>

      {/* Collapsible Section */}
      <tr ref={rowRef}>
        <td
          className="td-other-order-field"
          colSpan={11}
          style={{ padding: 0, border: 0 }}
        >
          <div
            ref={contentRef}
            style={{
              maxHeight: height,
              overflow: "hidden",
              transition: "max-height 0.4s ease, opacity 0.3s ease",
              opacity: isOpen ? 1 : 0,
            }}
            className="other-collapse-content"
          >
            {/* Toggle with text links */}
            <div
              className="expand-links"
              style={{
                padding: "10px 20px",
                borderBottom: "1px solid #ddd",
                display: "flex",
                gap: "15px",
              }}
            >
              <span
                onClick={() => setActiveTab("items")}
                style={{
                  cursor: "pointer",
                  color: activeTab === "items" ? "#007bff" : "#555",
                  textDecoration: activeTab === "items" ? "underline" : "none",
                  fontWeight: activeTab === "items" ? "600" : "400",
                }}
              >
                View Items
              </span>
              <span
                onClick={() => setActiveTab("receipt")}
                style={{
                  cursor: "pointer",
                  color: activeTab === "receipt" ? "#007bff" : "#555",
                  textDecoration:
                    activeTab === "receipt" ? "underline" : "none",
                  fontWeight: activeTab === "receipt" ? "600" : "400",
                }}
              >
                View Receipt
              </span>
            </div>

            {activeTab === "items" && (
              <>
                {transaction.PaymentType === "full" ? (
                  <>
                    <div className="items-list">
                      <div className="ord-prod-items-header">
                        <div className="ord-blank"></div>
                        <div className="ord-prod-name">Product Name</div>
                        <div className="ord-prod-quantity">Quantity</div>
                        <div className="ord-prod-unitprice">Unit Price</div>
                        <div className="ord-prod-dpunit">
                          Deposited <br />
                          Amount
                        </div>
                        <div className="ord-prod-dptotal">Balance</div>
                      </div>
                    </div>

                    <div className="items-list">
                      {transaction.OrderItems.map((item) => (
                        <div key={item.id} className="ord-prod-items">
                          <img
                            src={`${
                              process.env.REACT_APP_BASE_URL
                            }Assets/Products/${item.PD_ID}/${
                              item.IMG[0] ?? "no-image.png"
                            }`}
                            alt={item.ProductName}
                            className="ord-prod-pic"
                          />
                          <div className="ord-prod-name">
                            {item.ProductName}
                          </div>
                          <div className="ord-prod-quantity">
                            x{item.Quantity}
                          </div>
                          <div className="ord-prod-unitprice">
                            PHP {item.UnitPrice}
                          </div>
                          <div className="ord-prod-dpunit">
                            PHP {item.Deposited}
                          </div>
                          <div className="ord-prod-dptotal">
                            PHP {item.Balance}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="items-list">
                      <div className="ord-prod-items-header">
                        <div className="ord-blank"></div>
                        <div className="ord-prod-name">Product Name</div>
                        <div className="ord-prod-quantity">Quantity</div>
                        <div className="ord-prod-unitprice">Unit Price</div>
                        <div className="ord-prod-dpunit">
                          Downpayment <br />
                          (Per unit)
                        </div>
                        <div className="ord-prod-dptotal">
                          Downpayment <br />
                          Subtotal
                        </div>
                      </div>
                    </div>

                    <div className="items-list">
                      {transaction.OrderItems.map((item) => (
                        <div key={item.id} className="ord-prod-items">
                          <img
                            src={`${
                              process.env.REACT_APP_BASE_URL
                            }Assets/Products/${item.PD_ID}/${
                              item.IMG[0] ?? "no-image.png"
                            }`}
                            alt={item.ProductName}
                            className="ord-prod-pic"
                          />
                          <div className="ord-prod-name">
                            {item.ProductName}
                          </div>
                          <div className="ord-prod-quantity">
                            x{item.Quantity}
                          </div>
                          <div className="ord-prod-unitprice">
                            PHP {item.UnitPrice}
                          </div>
                          <div className="ord-prod-dpunit">
                            PHP {item.Downpayment}
                          </div>
                          <div className="ord-prod-dptotal">
                            PHP {item.Downpayment * item.Quantity}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </>
            )}

            {activeTab === "receipt" && (
              <div className="receipt-view">
                <img
                  src={`${
                    process.env.REACT_APP_BASE_URL
                  }Assets/purchase_order/${transaction.TransactionID}/${
                    transaction.Receipt ?? "no-image.png"
                  }`}
                  alt="Receipt"
                  className="receipt-img"
                  onLoad={() => {
                    if (contentRef.current) {
                      setHeight(`${contentRef.current.scrollHeight}px`);
                    }
                  }}
                />
              </div>
            )}
          </div>
        </td>
      </tr>
      <Modal
        isModalOpen={isModalOpen}
        onClose={() => {
          setModalOpen(null);
        }}
      >
        {isModalOpen === "approve" ? (
          <ApproveDeclined
            onClose={() => setModalOpen(null)}
            handleApprove={handleApprove}
          />
        ) : isModalOpen === "refund" ? (
          <RefundForm
            onClose={() => setModalOpen(null)}
            handleRefund={handleRefund}
          />
        ) : (
          ""
        )}
      </Modal>
    </>
  );
}

export default _OrderRow;
